var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", padding: "10px" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            { attrs: { "label-width": "40px", size: "mini" } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: {
                    label: _vm.$t("panel.space_top"),
                    prop: "marginTop",
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "hide-icon-number",
                      attrs: { type: "number", min: 0, max: _vm.maxTop },
                      model: {
                        value: _vm.styleInfo.top,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "top", $$v)
                        },
                        expression: "styleInfo.top",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("px")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: {
                    label: _vm.$t("panel.space_left"),
                    min: 0,
                    prop: "marginTop",
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "hide-icon-number",
                      attrs: { type: "number", min: 0, max: _vm.maxLeft },
                      model: {
                        value: _vm.styleInfo.left,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "left", $$v)
                        },
                        expression: "styleInfo.left",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("px")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: {
                    label: _vm.$t("panel.space_width"),
                    min: 0,
                    prop: "marginTop",
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "hide-icon-number",
                      attrs: { min: 0, max: _vm.maxWidth, type: "number" },
                      model: {
                        value: _vm.styleInfo.width,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "width", $$v)
                        },
                        expression: "styleInfo.width",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("px")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("panel.space_height"), min: 0 },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "hide-icon-number",
                      attrs: { type: "number", min: 0, max: _vm.maxHeight },
                      model: {
                        value: _vm.styleInfo.height,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "height", $$v)
                        },
                        expression: "styleInfo.height",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("px")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }